export type SubjectIndicatorCountPayload = {
	subjectType: { id: number };
	count: number;
};

export type SubjectIndicatorsPayload = {
	queryKey: string;
	counts: SubjectIndicatorCountPayload[];
};

export type SubjectIndicatorsFetchedAction = {
	type: 'SUBJECT_INDICATORS_FETCHED';
	payload: SubjectIndicatorsPayload;
};

export default (payload: SubjectIndicatorsPayload): SubjectIndicatorsFetchedAction => ({
	type: 'SUBJECT_INDICATORS_FETCHED',
	payload,
});
